export const cs = {
    Lang_cs: "Česky",
    Lang_en: "Anglicky",
    button_Pokracovat: "Pokračovat",
    button_Close: "Zavřít",
    TypOvereniSubjektu: "Způsob ověření",
    TypOvereniSubjektu_DOKLAD_CISLO: "Doklad",
    TypOvereniSubjektu_JMENO_PRIJMENI_DATUMNAR: "Jméno, příjmení a datum narození",
    SetFirstPassword_Overeni: "Pro pokračování prosím vyplňte údaje pro ověření",
    SetFirstPassword_HesloNastaveno: "Heslo bylo nastaveno.",
    Form_HeslaNeshoduji: "Hesla se neshodují",
    TypDokladu_ID: "Občanský průkaz",
    TypDokladu_P: "Cestovní doklad",
    TypDokladu_OSTATNI: "Ostatní",
    TypDokladu_IR: "Povolení k pobytu",
    TypDokladu_VS: "Vízový štítek",
    TypDokladu_PS: "Pobytový štítek",
    TypDokladu_RP: "Řidičský průkaz",
    DokladForm_idDoklad_required: "Číslo dokladu je povinné",
    DokladForm_idDoklad_minLength: "Číslo dokladu musí mít minimálně 8 znaků",
    DokladForm_idDoklad_maxLength: "Číslo dokladu nesmí být delší než 9 znaků",
    DokladForm_typDokladu_required: "Typ dokladu je povinný",
    DokladForm_typOvereniSubjektu_required: "Způsob ověření je povinný",
    DokladForm_jmeno_required: "Jméno je povinné",
    DokladForm_prijmeni_required: "Příjmení je povinné",
    DokladForm_datumNarozeni_required: "Datum narození je povinný",
    DokladForm_cisloDokladu: "Číslo dokladu",
    DokladForm_jmeno: "Jméno",
    DokladForm_prijmeni: "Příjmení",
    DokladForm_datumNarozeni: "Datum narození",
    NewPasswordForm_newPassword: "Nové heslo",
    NewPasswordForm_newPassword_repeat: "Nové heslo znovu",
    UserAgreementFormSection_agreement: "Souhlasím se {1} a {2}.",
    UserAgreementFormSection_gdpr: "zpracováním osobních údajů",
    UserAgreementFormSection_terms: "podmínkami užívání portálu",
    UserAgreementFormSection_agreement2: "Souhlasím se {1}.",
    UserAgreementFormSection_gdpr_and_terms: "zpracováním osobních údajů a podmínkami užívání portálu",
    UserAgreementFormSection_gdpr_detail: "Souhlas se zpracováním osobních údajů",
    UserAgreementFormSection_terms_detail: "Souhlas s podmínkami užívání portálu",
    ProcessLoginForm_cisloDokladu_required: "Zadejte číslo dokladu",
    Form_agreement_required: "Musíte souhlasit se zpracováním osobních údajů a podmínkami užívání portálu.",
    NewPasswordForm_newPassword_required: "Heslo je povinné",
    NewPasswordForm_newPassword_repeat_required: "Heslo znovu je povinné",
    ResetPasswordPage_obnoveniHesla: "Obnovení hesla",
    ResetPasswordPage_done: "Pokud je e-mail registrován u aktivního účtu, byl Vám odeslán e-mail s informací k obnově hesla.",
    ResetPasswordForm_login: "Přihlašovací jméno",
    ResetPasswordForm_login_required: "Přihlašovací jméno je povinné",
    ResetPasswordForm_captcha_required: "Ověření zda nejste robot je povinné",
    ResetPasswordForm_info: "Zadejte přihlašovací jméno. Na registrovaný email Vám budou odeslány informace pro obnovení hesla.",
    ResetPasswordForm_button_obnovitHeslo: "Obnovit heslo",
    PasswordChangePage_title: "Nastavení hesla",
    NewPasswordForm_button_nastavitHeslo: "Nastavit heslo",
    PasswordChangePage_hesloNastaveno: "Heslo bylo nastaveno. Nyní se můžete přihlásit.",
    PasswordChangePage_continueLogin: "Pokračovat na přihlášení",
    TypAutentizace_JMENO_HESLO: "Uživatelské jméno ({0}) a heslo",
    TypAutentizace_NIA: "Identita občana",
    TypAutentizace_MOJE_ID: "MojeID",
    TypAutentizace_ISDS: "Datová schránka",
    TypAutentizace_JMENO_HESLO_INVALID: "Jméno a heslo není nastaveno.",
    TypAutentizace_NIA_INVALID: "eidentita nebyla připojena.",
    TypAutentizace_MOJE_ID_INVALID: "Účet MojeID nebyl připojen.",
    TypAutentizace_ISDS_INVALID: "Účet datové schránky nebyl připojen.",
    ProcessLoginPage_procesPrihlaseni: "Proces přihlášení",
    ProcessLoginPage_chybaPrihlaseni: "Chyba přihlášení",
    ProcessLoginForm_button_dokoncitPrihlaseni: "Dokončit přihlášení",
    ProcessLoginPage_action_opakovatPrihlaseni: "Opakovat přihlášení",
    ProcessLoginPage_action_zmenitPrihlaseni: "Změnit způsob přihlášení přihlášení",
    ProcessLoginPage_loginError: "Přihlášení selhalo, opakujte akci později.",
    ProcessLoginPage_maloDat1: "Nebyly předány povinné položky pro přihlášení.",
    ProcessLoginPage_maloDat2: "Prosím opakujte přihlášení.",
    ProcessLoginPage_registraceJmenoHesloNotSupported: "Registrace pomocí uživatelského jména a hesla je dostupná pouze na přepážce úřadu.",
    ProcessLoginPage_nepredano: "nepředáno",
    ProcessLoginPage_predano: "předáno",
    ProcessLoginPage_malaUroven: "účet nemá dostatečnou úroveň ověření",
    ProcessLoginPage_jmeno: "Jméno",
    ProcessLoginPage_prijmeni: "Příjmení",
    ProcessLoginPage_datumNarozeni: "Datum narození",
    ProcessLoginPage_adresa: "Adresa",
    ProcessLoginPage_urovenDuveryhodnosti: "Úroveň důvěryhodnosti",
    ProcessLoginPage_nodata_jmenoPrijmeni: "Jméno a příjmení nebylo předáno",
    ProcessLoginPage_nodata_adresa: "Adresa nebyla předána",
    ProcessLoadingPage: "Načítání..."
}
